module.exports = __webpack_public_path__ + "static/media/logo.5bc37b9b.png";